import React from 'react';
import { ZonedDateTime } from '@payer-admin-ui/api/src/external/java/ZonedDateTime';
import { DateTimeFormat } from './DateTimeFormat';

export const ShortDateTime = ({ dateTime, ...props }: { dateTime: ZonedDateTime }) => {
  return <DateTimeFormat dateTime={dateTime} timeStyle="short" tooltip {...props} />;
};
